import React from "react";
import { Info } from "lucide-react";
import { ukFacts, ukSections, ukDisclaimer } from "../content/ukEconomy";

import { tr } from "../i18n";
const Block = ({ b }) => {
  if (b.note)
    return (
      <div className="flex gap-3 rounded-xl bg-[#f6f2e9] border-l-4 border-[#c2a15a] p-5 text-[15px] text-[#0b1f3a]/80 leading-relaxed">
        <Info size={18} className="shrink-0 mt-0.5 text-[#c2a15a]" />
        <p dangerouslySetInnerHTML={{ __html: b.note }} />
      </div>
    );
  if (b.html)
    return <p className="uk-prose" dangerouslySetInnerHTML={{ __html: b.html }} />;
  return <p className="uk-prose">{b.p}</p>;
};

export default function UKEconomySection() {
  return (
    <section id="uk-economy" data-testid="uk-economy-section" className="bg-[#fbf9f4] py-20 md:py-28 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <header className="reveal grid lg:grid-cols-[1fr_1.2fr] gap-10 lg:gap-16 items-end mb-16">
          <div>
          <div className="deco-line w-24 mb-6" />
          <span className="text-[12px] uppercase tracking-widest text-[#c2a15a] font-medium">{tr("Market Insight · 2026")}</span>
          <h2 className="font-display text-[30px] md:text-[38px] text-[#0b1f3a] leading-tight mt-3">
            {tr("Saving in the United Kingdom after Brexit")}
          </h2>
          <nav className="flex flex-wrap gap-2 mt-6 text-[13px]">
            {ukSections.map((s) => (
              <a key={s.id} href={`#uk-${s.id}`} data-testid={`uk-economy-nav-${s.id}`}
                className="px-3 py-1.5 rounded-full ring-1 ring-[#0b1f3a]/15 text-[#0b1f3a]/70 hover:text-[#0b1f3a] hover:ring-[#c2a15a] transition-colors">
                {s.id === "situation" ? tr("Economic situation") : s.title}
              </a>
            ))}
          </nav>
          </div>
          <div className="grid grid-cols-2 gap-3" data-testid="uk-economy-facts">
            {ukFacts.map((f) => (
              <div key={f.label} className="rounded-xl bg-[#0b1f3a] p-4">
                <div className="font-display text-[22px] text-[#c2a15a]">{f.value}</div>
                <div className="text-[12px] text-white/70 mt-1 leading-snug">{f.label}</div>
              </div>
            ))}
          </div>
        </header>

        <article className="max-w-3xl space-y-14 lg:ml-[8%]">
          {ukSections.map((s) => (
            <div key={s.id} id={`uk-${s.id}`} className="reveal space-y-5 scroll-mt-28" data-testid={`uk-economy-${s.id}`}>
              <h3 className="font-display text-[24px] md:text-[30px] text-[#0b1f3a] leading-snug">{s.title}</h3>
              {s.blocks.map((b, i) => <Block key={i} b={b} />)}
            </div>
          ))}
          <p data-testid="uk-economy-disclaimer"
            className="reveal text-[13px] text-[#0b1f3a]/55 leading-relaxed border-t border-[#0b1f3a]/10 pt-6"
            dangerouslySetInnerHTML={{ __html: tr(ukDisclaimer) }} />
        </article>
      </div>
    </section>
  );
}
